import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";

function Header({ fontColor = "black", backgroundColor = "white" }) {
  const LinkButton = ({ to, title }) => (
    <Button 
      fontFamily="roboto slab" 
      color="inherit" 
      component={Link} 
      to={to} 
      sx={{ 
        marginX: { xs: 0.5, sm: 1.5, md: 3 },
        fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
        padding: { xs: "6px 8px", sm: "6px 12px", md: "6px 16px" }
      }}
    >
      {title}
    </Button>
  );

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: backgroundColor,
        color: fontColor,
        boxShadow: 0
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, paddingX: { xs: 1, sm: 2 } }}>
        <Typography
          variant="h5"
          sx={{ 
            flexGrow: 1,
            fontSize: { xs: "1rem", sm: "1.25rem", md: "1.5rem" },
            whiteSpace: { xs: "nowrap", sm: "normal" }
          }}
          component={Link}
          to="/"
          fontFamily="roboto slab"
          style={{ textDecoration: "none", color: fontColor }}
        >
          BRANDON McHUGH
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <LinkButton title="Experience" to="/experience" sx={{ color: fontColor }} />
          <LinkButton title="Projects" to="/projects" sx={{ color: fontColor }} />
          <Button
            fontFamily="roboto slab"
            color="inherit"
            component="a"
            href="https://www.linkedin.com/in/mchugh-brandon/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ 
              marginX: { xs: 0.5, sm: 1.5, md: 3 },
              fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
              padding: { xs: "6px 8px", sm: "6px 12px", md: "6px 16px" }
            }}
          >
            LinkedIn
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
